// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b7fd6297","94":"f3e963a3","191":"0a044181","344":"3a6f4ef5","451":"ce7e6f2e","469":"c253a57b","513":"ee32e41b","782":"a361f81b"}[chunkId] + ".chunk.js";
};